import type { DeepPartial } from '@luna/utils-ts';
import { BUNDLE_ORDER_TYPE } from '@shared/payments-types';

import type { PaymentOrders } from './PaymentOrders';

export const CZ: DeepPartial<PaymentOrders> = {
    showApplicationId: true,
    showLastModification: true,
    alwaysRedo: false,
    collectiveSigningAllowedCurrencies: ['CZK'],
    showTransactionIdInSigning: true,
    shouldDisplayDonationsTaxReductionMessage: true,
    orderBundler: {
        config: {
            DEFAULT: [
                {
                    combination: [BUNDLE_ORDER_TYPE.DOMESTIC_COLLECTIVE_SIGNING],
                    maxSize: 1,
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: true,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: true,
                },
                {
                    combination: [BUNDLE_ORDER_TYPE.OWN_FX],
                    maxSize: 1,
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: false,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: true,
                },
                {
                    combination: [BUNDLE_ORDER_TYPE.DOMESTIC],
                    maxSize: 20,
                    allowedCurrencies: ['CZK'],
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: true,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: true,
                },
                {
                    combination: [BUNDLE_ORDER_TYPE.SEPA],
                    maxSize: 1,
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: true,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: true,
                },
                {
                    combination: [BUNDLE_ORDER_TYPE.INTERNATIONAL],
                    maxSize: 1,
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: true,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: true,
                },
            ],
        },
        configForCollectiveSigning: {
            DEFAULT: [
                {
                    combination: [BUNDLE_ORDER_TYPE.DOMESTIC_COLLECTIVE_SIGNING_OPN],
                    maxSize: 20,

                    allowedCurrencies: ['CZK'],
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: false,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: true,
                },
                {
                    combination: [BUNDLE_ORDER_TYPE.OWN_FX],
                    maxSize: 1,
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: false,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: true,
                },
                {
                    combination: [BUNDLE_ORDER_TYPE.DOMESTIC],
                    maxSize: 20,
                    allowedCurrencies: ['CZK'],
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: true,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: true,
                },
                {
                    combination: [BUNDLE_ORDER_TYPE.SEPA],
                    maxSize: 1,
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: true,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: true,
                },
                {
                    combination: [BUNDLE_ORDER_TYPE.INTERNATIONAL],
                    maxSize: 1,
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: true,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: true,
                },
            ],
        },
    },
    failedOrderStates: [
        'BAN',
        'CBB',
        'KAG',
        'RDE',
        'SNM',
        'NGD',
        'NGA',
        'ADB',
        'NBA',
        'CBA',
        'CSA',
        'LGR',
        'BLA',
        'ABG',
        'BBC',
        'AGB',
        'OBG',
        'UNG',
        'BNZ',
        'ENE',
        'FUS',
        'UNK',
        'DDB',
        'DDD',
        'DDL',
        'DDC',
        'RED',
        'XPR',
        'BAM',
        'BPA',
        'BPR',
        'EEI',
        'FRD',
        'IPA',
        'IPC',
        'IPE',
        'ISA',
        'RBC',
        'REC',
    ],
    requestDoubleSigningInCaseOfPossibleFraud: true,
    shouldDisplayTacInfo: false,
};
